import { useEffect } from 'react'

/**
 *
 *  Send a array of requests intances to be aborted on didmount if are not completed
 * @export
 * @param {*} [requestsArray=[]]
 */
export default function useAbortRequestsOnDidMount(requestsArray = []) {
  useEffect(componentWillUnmount, [])
  function componentWillUnmount() {
    return () => {
      requestsArray.forEach(request => request && typeof request !== `function` && request.abort())
    }
  }
}
